import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@mui/styles";
import {FsVarVariant} from "../config/FusionConfig";
import Tooltip from "@mui/material/Tooltip";

const HoverView = withStyles((theme) => ({
    tooltip: {
        color: "black",
        fontsize: `${FsVarVariant.MD} !important`,
        textAlign: "start",
        display: "flex",
        padding: ".15rem .3rem !important",
        justifyContent: "center",
        boxShadow: "var(--shadowLg)",
        backgroundColor: "white",
        borderRadius: ".5rem",
        width: "auto", // Set your desired width
        minWidth: "auto", // Set your desired width
        maxWidth: "300px", // Set your desired width
        height: 'auto', // Set your desired height
        maxHeight: '180px', // Set your desired height
        // maxHeight: getJsonValue(props, 'height', "180px"), // Set your desired height
        // overflow: 'auto', // Enable scroll bar when content overflows
    },
}))(Tooltip);

const Popover = ({
                     className = "",
                     children,
                     title,
                     minShowLimit = -1,
                     style = {},
                 }) => {
    const TAG = "Popover";

    useEffect(() => {

    }, []);
    useEffect(() => {

    }, [children]);

    return (<>
            <HoverView
                title={<span className={'px-2'}>
                    {title}
                </span>}
                classes={{tooltip: "scroller scroller-y-auto scroll-dark p-2"}}
                height={'50px'}>
                {children}
            </HoverView>
        </>
    )
}
Popover.propTypes = {
    className: PropTypes.string,
    title: PropTypes.any,
    children: PropTypes.any,
    style: PropTypes.object,
};
export default Popover;
